import React from 'react'

const Whitepaper = () => {
  return (
    <div>Whitepaper</div>
  )
}

export default Whitepaper